export default __webpack_public_path__ + "static/media/bg-pattern-top.dae77b1f.svg";